module.exports = __webpack_public_path__ + "static/media/ico-dom.1b041820.svg";